export * from './ng-4-geoautocomplete.module';
//# sourceMappingURL=index.js.map